// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","error":"App_error__1umzI"};